export default "__VITE_ASSET__BhSWPsf5__"